const BASE_URL = process.env.REACT_APP_ZVB_URL ;

// Function to return the Authorization header in Bearer format
const getAuthHeader = () => {
  const token = localStorage.getItem("authToken");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// Function to attach authentication header 
export const authenticatedFetch = async (url, options = {}) => {
  const headers = {
    Accept: "application/json",
    ...getAuthHeader(),
    ...options.headers,
  };

  if (!(options.body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  return fetch(url, { ...options, headers });
};


// API to login 
export const login = async (email, password) => {
  try {
    const response = await fetch(`${BASE_URL}/login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ email, password }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || "Login failed");
    }

    const data = await response.json();
    return data; // Should contain { user: {...}, token: "..." }
  } catch (error) {
    console.error("Login error:", error);
    throw error;
  }
};
// API to logout
export const logout = async () => {
  try {
    const response = await authenticatedFetch(`${BASE_URL}/logout`, {
      method: "POST",
    });

    if (!response.ok) {
      throw new Error(`Logout failed: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error logging out:", error);
    throw error;
  }
};
